import { createContext } from 'react';
export var TreeContext = createContext({});
